import { getNewestNews, getOrgid, getLabelList } from '../../services/schoolMatrix/latestNews';

const initState = {};

export default {
  namespace: 'latestNews',
  state: initState,
  effects: {
    *fetchNewestNews({ params }, { call }) {
      try {
        const response = yield call(getNewestNews, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchOrgid({ params }, { call }) {
      try {
        const response = yield call(getOrgid, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchLabelList({ params }, { call }) {
      try {
        const response = yield call(getLabelList, params);
        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
